module.exports = __webpack_public_path__ + "static/img/3_1.6b0208c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/showcase/preview/department/3_1.png
// module id = 5jHe
// module chunks = 1